<template>
    <div class="home-partners">
        <router-link to="/all_partners">
            <content-header class="home-content home-content-header" text="Партнеры"/>
        </router-link>
        <partners-cards/>
    </div>
</template>
<script>

import ContentHeader from '@/components/content/ContentHeader.vue'
import PartnersCards from '@/components/partners/PartnersCards.vue';

export default{
    name: 'HomePartners',
    components: {
        ContentHeader,
        PartnersCards
    }
}
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
    color: unset;
}
</style>